<script setup lang="ts">
  import { computed } from 'vue';
  import { useRoute } from 'vue-router';
  import { Loader2 } from 'lucide-vue-next';
  import { ColoredButton } from '@/shared/ui';
  import { useTrainingMatrixEditIndividual } from '../model/useTrainingMatrixEditIndividual';
  import TrainingMatrixDocumentSection from './TrainingMatrixDocumentSection.vue';

  const route = useRoute();
  const positionId = computed(() => Number(route.params.positionId));

  const {
    sections,
    positionName,
    loading,
    isSaving,
    updateSearch,
    updateSearchField,
    updateSelectedItems,
    save,
    cancel,
  } = useTrainingMatrixEditIndividual(positionId.value);
</script>

<template>
  <div
    data-testid="training-matrix-edit-individual-page"
    class="p-6"
  >
    <div
      v-if="loading"
      class="flex justify-center py-12"
      data-testid="training-matrix-edit-individual-loading"
    >
      <Loader2 class="h-6 w-6 animate-spin text-[var(--theme-secondary-ink)]" />
    </div>

    <template v-else>
      <h1
        data-testid="training-matrix-edit-individual-title"
        class="text-xl font-semibold text-gray-07 mb-6"
      >
        Editar Matriz
      </h1>

      <div class="flex flex-col gap-5 rounded-t-2xl border border-b-0 border-gray-02 bg-white-01">
        <div class="border-b border-gray-02 px-6 py-3 flex gap-2 text-sm">
          <h3 class="font-semibold text-gray-07 shrink-0">Cargo:</h3>
          <p
            data-testid="training-matrix-edit-individual-position-name"
            class="font-medium"
          >
            {{ positionName }}
          </p>
        </div>

        <TrainingMatrixDocumentSection
          v-for="(section, index) in sections"
          :key="section.prefixCode"
          :section="section"
          :section-index="index"
          @search="updateSearch"
          @update:search-field="updateSearchField"
          @update:selected-items="updateSelectedItems"
        />
      </div>
    </template>

    <div class="sticky bottom-0 z-10 flex justify-end gap-6 rounded-b-2xl border border-t-0 border-gray-02 bg-white-01 px-6 py-8">
      <ColoredButton
        text="Cancelar"
        outlined
        :disabled="isSaving"
        @click="cancel"
      />
      <ColoredButton
        text="Salvar"
        :loading="isSaving"
        @click="save"
      />
    </div>
  </div>
</template>
